import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  Image,
  Box,
  ModalHeader,
  Flex,
} from "@chakra-ui/react";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  values: any;
};

export default function SetDefaultModal({
  isOpen,
  onClose,
  values,
}: ModalProps): JSX.Element {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>
          <Text>{values?.value?.name && values?.value?.name?.split('.')[0]}</Text>
        </ModalHeader>
        <ModalBody>
          <Flex justifyContent="center">
            <Image src={values?.value?.file} />
          </Flex >
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
}
